import { render, staticRenderFns } from "./ThanksForRegistering.vue?vue&type=template&id=2dded730"
import script from "./ThanksForRegistering.vue?vue&type=script&lang=js"
export * from "./ThanksForRegistering.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports